module.exports = __webpack_public_path__ + "img/BioShock2_cover.f10abb31.jpg";